<template>
  <div class="wrappertabs">
    <search-group title="" @search="findData" @clear="clearValue" :span="24" :btnOffset="20" :btnSpan="6"
                  :multipleLines="false" :inline="true"
                  style="padding: 0"
    >
      <Row class="mb16" :gutter="16">
        <Col span="6">
          <Select v-model="searchData.projectFid"  placeholder="项目名称">
            <Option value=''>请选择</Option>
            <Option v-for="(item,index) in projectList" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="3">
          <Select v-model="searchData.monthStr" placeholder="归属月份">
                        <Option value=''>请选择</Option>
                        <Option v-for="(item,index) in monthList" :value="item" :key="'keyB'+index">{{item}}</Option>
          </Select>
        </Col>
        <Col span="6">
          <DatePicker style="width:100%" v-model="searchData.createTime" format="yyyy-MM-dd" split-panels type="daterange" placeholder="创建日期筛选"></DatePicker>
        </Col>
        <Col span="5">
          <Input placeholder="请搜索姓名" v-model="searchData.name"></Input>
        </Col>
      </Row>
    </search-group>

    <table-list
      class="mt12"
      :columns="columns"
      :data="data"
      :current="current"
      :total="total"
      :loading="loading"
      @change-page="changPage"
    ></table-list>
    <info :n="infoN" :data="itemData"></info>

  </div>
</template>

<script type="text/ecmascript-6">
  // import SearchGroup from 'components/SearchGroup/index';
  import {formatDateTime} from "../../../../../utils/format";
  import TableList from 'components/TableList/index';
  import {commissionlist,monthscondition} from "../../../../../api/gop";
import {getProjects} from "../../../../../api/common";
import Info from './Info'
  import {formatMoney} from "../../../../../utils/format";

  export default {
    components: {
      // SearchGroup,
      TableList,
      Info
    },
    mounted() {
      monthscondition().then(res=>{
        if(!res.data){
          return
        }
        this.monthList=res.data

      }).catch(error=>{})

      getProjects().then(res => {
        if(!res.data){
          return
        }
        this.projectList = res.data
        // if(this.projectList.length){
        //   this.searchData.projectFid=this.projectList[0].value
        //   this.findData()
        // }
          this.findData()


      }).catch(error => {
      })

    },
    computed: {
      searchDataComputed() {
        function f(data) {
          return data ? formatDateTime(data, false) : ''
        }
        return {
          name:this.searchData.name,
          projectFid: this.searchData.projectFid,
          calcStartDate: f(this.searchData.createTime[0]),
          calcEndDate:f(this.searchData.createTime[1]),
          monthStr:this.searchData.monthStr

        }
      }
    },
    data() {
      return {
        infoN:0,
        itemData:null,
        projectList:[],
        monthList:[],
        searchParams:null,
        data: [],
        columns: [
          {
            type: 'index',
            width: 60,
            align: 'center'
          },
          {
            title: ' '
          },
          {
            title: '项目名称 ',
            align: 'center',
            key: 'projectName',
            width: 130,
          },

          {
            title: ' '
          },
          {
            title: "姓名",
            align: 'center',
            key: 'zoName',
            width: 120,
          },
          {
            title: ' '
          },
          {
            title: '角色',
            align: 'center',
            key: 'zoRoleName',
            width: 130,
            // render: (h, params) => {
            //   return h('span', {}, this.format(params.row['createTime']))
            // }

          },
          {
            title: ' '
          },
          {
            title: "提佣",
            align: 'center',
            key: 'commissionPersonal',
            width: 120,
            render:(h,params)=>{
              return h('span',{},formatMoney(params.row['commissionPersonal']))
            }
          },
          {
            title: ' '
          },        {
            title: "归属月份",
            align: 'center',
            key: 'belongToMonth',
            width: 120,
          },
          {
            title: ' '
          },

          {
            title: "计算日期",
            align: 'center',
            key: 'calcDate',
            width: 120,
            render:(h,params)=>{
              return h('span',{},formatDateTime(params.row['calcDate'],false))

            }
          },

          {
            title: ' '
          },
          {
            title: '操作',
            align: 'center',
            key: 'action',
            width: 120,
            fixed: 'right',
            render: (h, params) => {
              return h('div', [
                h('a', {
                  style: {
                    // display: params.row.reservationStatus === 2 ?'inline-block' :'none',
                    marginRight: '5px'
                  },
                  // directives:[
                  //   {
                  //     name:'p',
                  //     value:{
                  //       // api:'meta/updateMeta'
                  //     }
                  //   }
                  // ],
                  on:{
                    click: ()=>{
                      this.itemData=params.row
                      this.infoN++
                    }
                  }
                }, '查看'),

              ])
            }
          }
        ],
        total: 0,
        current: 1,
        loading: false,
        metaList:[],
        page:1,
        limit:10,
        searchData: {
          projectFid: '',
          createTime:['',''],
          name:'',
          monthStr:''

        },
      }
    },
    methods: {
      getData(){
        let params={
          ...this.searchParams,
          page:this.page,
          limit:this.limit
        }
        commissionlist(params).then(res=>{
          if(!res.data){
            return
          }
          this.total=res.data.total
          res.data.rows&& (this.data=res.data.rows)

        }).catch(error=>{
        })

      },
      changPage(n){
        this.current = n;
        this.page = n;
        this.getData()
      },
      findData() {
        this.searchParams=this.searchDataComputed
        this.page=1
        this.current=1
        this.getData()
      },
      clearValue() {
        this.searchData = {
          projectFid: '',
          createTime: ['', ''],
          condition:'',
          businessCode:'',
          belongToMonth:'',
        }
      },
    },
  }
</script>

<style scoped>
  .width3 {
    width: 200px;
  }
  .wrappertabs{
    min-height: 400px;

  }
</style>
